;(function() {
/* @ngInject */
function LegislationInfoBannerController(ModalLegislationInfo) {
  let vm = this;

  vm.$onInit = onInit;
  vm.showMoreInfo = showMoreInfo;

  function onInit() {
    let variant = vm.variant === "change" ? "change" : "create";
    vm.infoTranslationKey = "sro.legislationInfo." + variant;
  }

  function showMoreInfo() {
    ModalLegislationInfo(
      "sro.legislationInfo.title",
      "sro.legislationInfo.modalText"
    )
      .add()
      .result
      .then();
  }
}

angular.module("firmaren")
  .component("legislationInfoBanner", {
    templateUrl: "/app/shared/legislation-info-banner/legislation-info-banner.html",
    controller: LegislationInfoBannerController,
    controllerAs: "vm",
    bindings: {
      variant: "@"
    }
  });
}());
